import Pause from '../../../assets/pause.svg';

// Circled pause, drawn to match Freddy's PlayCircled. Freddy's icon set has no pause icon;
// replace this with it once one exists.
const PauseIcon = ({
  color,
  size = 16,
  ...props
}: React.SVGProps<SVGSVGElement> & { color: string; size?: number }): JSX.Element => {
  return <Pause fill={color} width={size} height={size} {...props} />;
};

export default PauseIcon;
